/* eslint-disable import/no-duplicates */
/* eslint-disable react/button-has-type */
/* eslint-disable object-shorthand */
/* eslint-disable func-names */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/jsx-boolean-value */
import React, { useRef, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";


export default function MySwiper() {
    const swiperRef = useRef(null);
    const [index, setIndex] = useState(1);

    const handlePaginationClick = (index) => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slideTo(index);
        }
    };

    const handlePrevClick = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slidePrev();
            setIndex(index - 1);
        }
    };

    const handleNextClick = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slideNext();
            setIndex(index + 1);
        }
    };

    return (
        <>
            <div>
                <Swiper
                    ref={swiperRef}
                    watchSlidesProgress={true}
                    slidesPerView={1}
                    className="mySwiper"
                    pagination={{
                        clickable: true,
                        renderBullet: function (index, className) {
                            return (
                                // eslint-disable-next-line react/self-closing-comp
                                <span
                                    className={className}
                                    onClick={() => handlePaginationClick(index)}
                                ></span>
                            );
                        },
                    }}
                >
                    <SwiperSlide>
                        <div className='subscription-card'>
                            <div className='d-flex justify-content-end'>
                                <h4>Visa</h4>
                            </div>
                            <p>Card Number</p>
                            <div className='d-flex justify-content-between w-100 align-items-center'>
                                <div className='d-flex justify-content-between w-100 align-items-center pt-3 px-4 mb-3' style={{ background: 'hsla(0,0%,100%,.11)' }}>
                                    <h6 className='fw-lighter'>***</h6>
                                    <h6 className='fw-lighter'>***</h6>
                                    <h6 className='fw-lighter'>***</h6>
                                    <h6 className='fw-lighter'>647</h6>
                                </div>
                            </div>
                            <div className='d-flex w-100 gap-4'>
                                <div className='w-50'>
                                    <p>Name</p>
                                    <div className='d-flex justify-content-center w-100 align-items-center pt-3' style={{ background: 'hsla(0,0%,100%,.11)' }}>
                                        <p className='fw-lighter'> D D D D</p>
                                    </div>
                                </div>
                                <div className='w-25'>
                                    <p>CVV</p>
                                    <div className='d-flex justify-content-center w-100 align-items-center pt-3' style={{ background: 'hsla(0,0%,100%,.11)' }}>
                                        <p className='fw-lighter'>***</p>
                                    </div>
                                </div>
                                <div className='w-25'>
                                    <p>Expiry Date</p>
                                    <div className='d-flex justify-content-center w-100 align-items-center pt-3' style={{ background: 'hsla(0,0%,100%,.11)' }}>
                                        <p className='fw-lighter'>11 / 28</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className='subscription-card'>
                            <div className='d-flex justify-content-end'>
                                <h4>Visa</h4>
                            </div>
                            <p>Card Number</p>
                            <div className='d-flex justify-content-between w-100 align-items-center'>
                                <div className='d-flex justify-content-between w-100 align-items-center pt-3 px-4 mb-3' style={{ background: 'hsla(0,0%,100%,.11)' }}>
                                    <h6 className='fw-lighter'>***</h6>
                                    <h6 className='fw-lighter'>***</h6>
                                    <h6 className='fw-lighter'>***</h6>
                                    <h6 className='fw-lighter'>647</h6>
                                </div>
                            </div>
                            <div className='d-flex w-100 gap-4'>
                                <div className='w-50'>
                                    <p>Name</p>
                                    <div className='d-flex justify-content-center w-100 align-items-center pt-3' style={{ background: 'hsla(0,0%,100%,.11)' }}>
                                        <p className='fw-lighter'> D D D D</p>
                                    </div>
                                </div>
                                <div className='w-25'>
                                    <p>CVV</p>
                                    <div className='d-flex justify-content-center w-100 align-items-center pt-3' style={{ background: 'hsla(0,0%,100%,.11)' }}>
                                        <p className='fw-lighter'>***</p>
                                    </div>
                                </div>
                                <div className='w-25'>
                                    <p>Expiry Date</p>
                                    <div className='d-flex justify-content-center w-100 align-items-center pt-3' style={{ background: 'hsla(0,0%,100%,.11)' }}>
                                        <p className='fw-lighter'>11 / 28</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className='subscription-card'>
                            <div className='d-flex justify-content-end'>
                                <h4>Visa</h4>
                            </div>
                            <p>Card Number</p>
                            <div className='d-flex justify-content-between w-100 align-items-center'>
                                <div className='d-flex justify-content-between w-100 align-items-center pt-3 px-4 mb-3' style={{ background: 'hsla(0,0%,100%,.11)' }}>
                                    <h6 className='fw-lighter'>***</h6>
                                    <h6 className='fw-lighter'>***</h6>
                                    <h6 className='fw-lighter'>***</h6>
                                    <h6 className='fw-lighter'>647</h6>
                                </div>
                            </div>
                            <div className='d-flex w-100 gap-4'>
                                <div className='w-50'>
                                    <p>Name</p>
                                    <div className='d-flex justify-content-center w-100 align-items-center pt-3' style={{ background: 'hsla(0,0%,100%,.11)' }}>
                                        <p className='fw-lighter'> D D D D</p>
                                    </div>
                                </div>
                                <div className='w-25'>
                                    <p>CVV</p>
                                    <div className='d-flex justify-content-center w-100 align-items-center pt-3' style={{ background: 'hsla(0,0%,100%,.11)' }}>
                                        <p className='fw-lighter'>***</p>
                                    </div>
                                </div>
                                <div className='w-25'>
                                    <p>Expiry Date</p>
                                    <div className='d-flex justify-content-center w-100 align-items-center pt-3' style={{ background: 'hsla(0,0%,100%,.11)' }}>
                                        <p className='fw-lighter'>11 / 28</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </SwiperSlide>
                </Swiper>
                <div className="d-flex justify-content-center mt-3">
                    <button className="border-0" style={{ background: 'none' }} onClick={handlePrevClick}>
                        <IoIosArrowBack />
                    </button>
                    <button className="border-0" style={{ background: 'none' }}>
                        {index} / 2
                    </button>
                    <button className="border-0" style={{ background: 'none' }} onClick={handleNextClick}>
                        <IoIosArrowForward />
                    </button>
                </div>
            </div>
        </>
    );
}
